import { PropsWithChildren, useContext } from 'react';
import { ErrorContext } from '../lib/ErrorContext';
import ErrorMessage from './ErrorMessage';
// import {error} from "../lib/Toast.js";

type InputContainerProps = {
    id?: string;
    label?: string;
    className?: string;
    error?: string;
};

const InputContainer = ({
    children,
    className,
    label,
    id,
    error,
}: PropsWithChildren<InputContainerProps>) => {
    const { errors } = useContext(ErrorContext);

    let errorMessage = error || '';
    if (id && errors && errors[id]) {
        errorMessage = errors[id];
    }

    return (
        <label
            className={`block${!!errorMessage ? ' is-error' : ''} ${className}`}
        >
            {!!label && <div className={`input-label`}>{label}</div>}
            {children}
            {!!errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
        </label>
    );
};

export default InputContainer;
